const axios = require('axios').default;

export const getGoodsReceiptLists = (props = {token:"", state:[0], businessId:0, supplierId:0}) => {
    return axios.get(`${process.env.REACT_APP_API_URL}/api/goodsReceipt/lists`, 
    {
        params:{
            state:props.state,
            businessId:props.businessId,
            supplierId:props.supplierId
        },
        headers: {
          'Authorization': `Basic ${props.token}`,
        }
    })
}

export const getGoodsReceipt = (props = {token:"", rlId:0}) => {
    return axios.get(`${process.env.REACT_APP_API_URL}/api/goodsReceipt/${props.rlId}`, 
    {
        params:{
            rlId:props.rlId
        },
        headers: {
          'Authorization': `Basic ${props.token}`,
        }
    })
}

export const postGoodsReceiptUploadImage = (props = {token:"", url:"", fileurl:"", filename:"", rlId:0}) => {
    return axios({
        url: `${process.env.REACT_APP_API_URL}/api/goodsReceipt/uploadImage`,
        method: "POST",
        headers: {
          "Authorization": 'Basic ' + props.token,
          'Content-Type': 'multipart/form-data'
        },params: {
            fileurl:props.fileurl,
            filename:props.filename,
            url:props.url,
            rlId:props.rlId
        }
    });
}

export const putGoodsReceiptMediaId = (props = {token:"", rlId:0, mediaId:''}) => {
    return axios({
        url: `${process.env.REACT_APP_API_URL}/api/goodsReceipt/mediaId`,
        method: "PUT",
        headers: {
          "Authorization": 'Basic ' + props.token
        },params: {
            rlId:props.rlId,
            mediaId:props.mediaId
        }
    });
}

export const putGoodsReceiptItemState = (props = {token:"", rliId:0, state:0}) => {
    return axios({
        url: `${process.env.REACT_APP_API_URL}/api/goodsReceipt/item/state`,
        method: "PUT",
        headers: {
          "Authorization": 'Basic ' + props.token
        },params: {
            rliId:props.rliId,
            state:props.state
        }
    });
}

export const putGoodsReceiptState = (props = {token:"", rlId:0, state:0}) => {
    return axios({
        url: `${process.env.REACT_APP_API_URL}/api/goodsReceipt/state`,
        method: "PUT",
        headers: {
          "Authorization": 'Basic ' + props.token
        },params: {
            rlId:props.rlId,
            state:props.state
        }
    });
}

export const putGoodsReceipt = (props = {token:"", rlId:0, data:{}}) => {
    return axios({
        url: `${process.env.REACT_APP_API_URL}/api/goodsReceipt`,
        method: "PUT",
        data: {
            data:props.data
        },
        headers: {
          "Authorization": 'Basic ' + props.token
        },params: {
            rlId:props.rlId
        }
    });
}